import { render } from "./UpdateMemberInfo.vue?vue&type=template&id=6a15af6d&scoped=true"
import script from "./UpdateMemberInfo.vue?vue&type=script&lang=js"
export * from "./UpdateMemberInfo.vue?vue&type=script&lang=js"

import "./UpdateMemberInfo.vue?vue&type=style&index=0&id=6a15af6d&scoped=true&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a15af6d"]])

export default __exports__